module.exports = __webpack_public_path__ + "img/stars.7f66b245.svg";